export default {
  "elk.direction": "RIGHT",
  "elk.algorithm": "layered",
  "elk.layered.spacing.nodeNodeBetweenLayers": "150",
  "elk.spacing.nodeNode": "100",
  "org.eclipse.elk.layered.nodePlacement.bk.edgeStraightening":
    "IMPROVE_STRAIGHTNESS",
  "elk.nodeLabels.placement": "INSIDE V_CENTER H_RIGHT",
  "org.eclipse.elk.zoomToFit": "true",
};
